var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configuration-tree"},[_c('configuration-tree-row',{model:{value:(_vm.configuration),callback:function ($$v) {_vm.configuration=$$v},expression:"configuration"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }